module.exports = __webpack_public_path__ + "static/media/newletter-bg.571ca22e.jpg";